export default __webpack_public_path__ + "static/media/img-0684-bosnia-half-face.a27e1489.png";